import React from 'react';
import LeadForm from './LeadForm';
import { Modal } from '@makemydeal/dr-activities-common';

// TODO: Remove this workaround when dr-activities-common is updated to React 18
const ModalWithChildren = Modal as React.ComponentType<any>;

export const LeadFormModal = (props: any) => {
    const { isActive, elementToBlur, elementToAttachModalTo, cls } = props;

    return (
        <ModalWithChildren show={isActive} elementToAttachModalTo={elementToAttachModalTo} elementToBlur={elementToBlur} cls={cls}>
            <LeadForm {...props} />
        </ModalWithChildren>
    );
};

export default LeadFormModal;
